module.exports = __webpack_public_path__ + "assets/img/thumb-SpinTel-Pillar-Page-Resource.40af375c.jpg";